import React, { useEffect } from 'react';
import { Grid } from 'vendors/semantic-ui';

import { PageTitle } from 'modules/shared-ui/components/typography';
import { LoginForm } from '../../components/login/login-form';
import { ChooseList } from '../../components';
import { LoginProps } from './login-type';

import enhancer from './login-page-enhancer';

import styles from './login-page.module.css';

const InnerLoginPage: React.FC<LoginProps> = ({ isAuthenticated, redirectPath, login, errorMessage }: LoginProps) => {
    useEffect(() => {
        const grid = document.getElementById('gridElement');
        const script = document.createElement('script');

        script.src = `${process.env.PUBLIC_URL}/script-login.js`;
        script.async = true;

        if (grid) {
            grid.appendChild(script);
        }

        return () => {
            if (grid) {
                grid.removeChild(script);
            }
        };
    }, []);

    return (
        <React.Fragment>
            <PageTitle title="Je me connecte" uppercase centered />
            <Grid id="gridElement" stackable columns={2}>
                <Grid.Column textAlign="center" className={styles.paddedColumn}>
                    <LoginForm
                        model={{ folderIdOrEmail: '', password: '' }}
                        isAuthenticated={isAuthenticated}
                        redirectPath={redirectPath}
                        onSuccess={model => login(model.folderIdOrEmail, model.password)}
                        errorMessage={errorMessage}
                    />
                </Grid.Column>
                <Grid.Column textAlign="center" className={styles.paddedColumn}>
                    <ChooseList />
                </Grid.Column>
            </Grid>
        </React.Fragment>
    );
};

export const LoginPage = enhancer(InnerLoginPage);
